import { SIRE_ESTADOS } from "./sireEstados";

const cleanText = (v) => (v == null ? "" : String(v).trim());

export const diagnosticarEstadoPeriodoSire = ({
  rucEmpresa,
  periodo,
  estadoRceObj,
  estadoRvieObj,
  diferenciasRce = 0,
  diferenciasRvie = 0,
}) => {
  const rceSt = estadoRceObj?.estado || SIRE_ESTADOS.NO_INICIADO;
  const rvieSt = estadoRvieObj?.estado || SIRE_ESTADOS.NO_INICIADO;

  const rceCerrado = rceSt === SIRE_ESTADOS.CERRADO || rceSt === SIRE_ESTADOS.ACEPTADO;
  const rvieCerrado = rvieSt === SIRE_ESTADOS.CERRADO || rvieSt === SIRE_ESTADOS.ACEPTADO;

  if (rceCerrado && rvieCerrado) {
    return {
      codigo: "PERIODO_COMPLETADO",
      titulo: "🟢 Período completado y al día",
      descripcion: `La contabilidad del período ${cleanText(periodo)} (RCE y RVIE) se encuentra presentada y aceptada por SUNAT.`,
      accion: "Esperar apertura del próximo período tributario.",
      tipoAccion: "info",
      desactualizado: false,
    };
  }

  if (rceSt === SIRE_ESTADOS.CONCILIACION_DESACTUALIZADA || rvieSt === SIRE_ESTADOS.CONCILIACION_DESACTUALIZADA) {
    return {
      codigo: "CONCILIACION_DESACTUALIZADA",
      titulo: "⚠️ Conciliación Desactualizada",
      descripcion: "SUNAT ha publicado una nueva versión de propuesta. Debe volver a conciliar antes de generar o presentar.",
      accion: "Re-conciliar con la nueva propuesta SUNAT",
      tipoAccion: "warning",
      desactualizado: true,
    };
  }

  if (diferenciasRce > 0 || diferenciasRvie > 0) {
    return {
      codigo: "RESOLVER_DIFERENCIAS",
      titulo: "🔴 Diferencias detectadas en conciliación",
      descripcion: `Existen ${diferenciasRce + diferenciasRvie} diferencias entre SUNAT y Mi Boleta. Debe resolverlas antes de generar.`,
      accion: "Revisar y resolver diferencias contables",
      tipoAccion: "danger",
      desactualizado: false,
    };
  }

  if (rceSt === SIRE_ESTADOS.NO_INICIADO || rvieSt === SIRE_ESTADOS.NO_INICIADO) {
    return {
      codigo: "CONSULTAR_PROPUESTAS",
      titulo: "🟡 Propuesta SUNAT pendiente de consulta",
      descripcion: "Consulte las propuestas oficiales de RCE y RVIE desde SUNAT API.",
      accion: "Consultar propuestas SUNAT",
      tipoAccion: "warning",
      desactualizado: false,
    };
  }

  return {
    codigo: "GENERAR_PRESENTAR",
    titulo: "🟢 Conciliado 100% — Listo para Presentar",
    descripcion: "La conciliación ha finalizado sin diferencias. Puede proceder con la generación y presentación a SUNAT.",
    accion: "Generar archivo y Presentar a SUNAT",
    tipoAccion: "success",
    desactualizado: false,
  };
};
